import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	titleDetailsAdmin: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	titleDetailsUser: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	submitCaption: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	cancelCaption: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	reasonTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	reasonPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	reasonParity: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	reasonSpeed: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	reasonBug: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	reasonOthers: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	reasonQuestion: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	titleDetailsAdminIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	titleDetailsUserIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	reasonTitleIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	title: {
		id: 'issue-navigator-changeboarding.common.opt-out-feedback.title',
		defaultMessage: "Let us know why you're moving",
		description:
			'It is a title for admins or users wanting to provide feedback on moving back to GIN.',
	},
	titleDetailsAdmin: {
		id: 'issue-navigator-changeboarding.common.opt-out-feedback.title-details-admin',
		defaultMessage: 'You and your users will be able to use the old issue search temporarily.',
		description:
			'It provides title details for admins wanting to provide feedback on moving back to GIN.',
	},
	titleDetailsUser: {
		id: 'issue-navigator-changeboarding.common.opt-out-feedback.title-details-user',
		defaultMessage: "You'll be able to use the old issue search temporarily.",
		description:
			'It provides title details for admins wanting to provide feedback on moving back to GIN.',
	},
	submitCaption: {
		id: 'issue-navigator-changeboarding.common.opt-out-feedback.submit-caption',
		defaultMessage: 'Send feedback',
		description: 'Primary CTA for opt-out NIN feedback dialog',
	},
	cancelCaption: {
		id: 'issue-navigator-changeboarding.common.opt-out-feedback.cancel-caption',
		defaultMessage: 'Skip',
		description: 'Secondary CTA for opt-out NIN feedback dialog',
	},
	reasonTitle: {
		id: 'issue-navigator-changeboarding.common.opt-out-feedback.reason-title',
		defaultMessage: 'What is your reason to go back to the old issue search?',
		description: 'Reason title for opt-out NIN feedback dialog',
	},
	reasonPlaceholder: {
		id: 'issue-navigator-changeboarding.common.opt-out-feedback.reason-placeholder',
		defaultMessage: 'Select an option',
		description:
			'Placeholder of the dropdown element where users will be able to select a reason for opting out of the New Issue Navigator',
	},
	reasonParity: {
		id: 'issue-navigator-changeboarding.common.opt-out-feedback.reason-parity',
		defaultMessage: 'Features are missing',
		description: 'A topic when providing feedback for feature parity; option in dropdown.',
	},
	reasonSpeed: {
		id: 'issue-navigator-changeboarding.common.opt-out-feedback.reason-speed',
		defaultMessage: "It's slow",
		description: 'A topic when providing feedback for slower experience; option in dropdown.',
	},
	reasonBug: {
		id: 'issue-navigator-changeboarding.common.opt-out-feedback.reason-bug',
		defaultMessage: "There's a bug",
		description: 'A topic when providing feedback for buggy experience; option in dropdown.',
	},
	reasonOthers: {
		id: 'issue-navigator-changeboarding.common.opt-out-feedback.reason-others',
		defaultMessage: 'Others',
		description: 'A topic when providing feedback for generic reason; option in dropdown.',
	},
	reasonQuestion: {
		id: 'issue-navigator-changeboarding.common.opt-out-feedback.reason-question',
		defaultMessage: "Can you provide more details? It'll help make search better for everyone.",
		description: 'Follow-up question after reason is given for opt-out NIN feedback dialog',
	},
	titleDetailsAdminIssueTermRefresh: {
		id: 'issue-navigator-changeboarding.common.opt-out-feedback.title-details-admin-issue-term-refresh',
		defaultMessage: "You'll be able to use the old way to search for work items temporarily.",
		description:
			'It provides title details for admins wanting to provide feedback on moving back to GIN.',
	},
	titleDetailsUserIssueTermRefresh: {
		id: 'issue-navigator-changeboarding.common.opt-out-feedback.title-details-user-issue-term-refresh',
		defaultMessage: "You'll be able to use the old way to search for work items temporarily.",
		description:
			'It provides title details for admins wanting to provide feedback on moving back to GIN.',
	},
	reasonTitleIssueTermRefresh: {
		id: 'issue-navigator-changeboarding.common.opt-out-feedback.reason-title-issue-term-refresh',
		defaultMessage:
			"What's the reason you're going back to the old way to searching for work items?",
		description: 'Reason title for opt-out NIN feedback dialog',
	},
});
export default messages;
